import useRecommendationsAPI from './useRecommendationsAPI'
import { Product } from '../../utils/types/Product'
import { VertexAIUserEventType } from '../../utils/constants'

interface UseSimilarItemsParams {
  associatedItems: string[]
  pageSize?: number
  defaultEventType?: VertexAIUserEventType
}

interface UseSimilarItemsResult {
  data: Product[] | undefined
  isLoading: boolean
  error: Error | undefined
  triggerDetailPageView: () => Promise<void>
}

/**
 * Hook for fetching similar items based on provided product codes. Product level
 *
 * @param params Parameters for the hook
 * @returns Similar products and function to trigger detail page view event.
 * Products will only load when a trigger event gets called.
 */
const useSimilarItems = (
  params: UseSimilarItemsParams,
): UseSimilarItemsResult => {
  const {
    associatedItems = [],
    defaultEventType = 'detail-page-view',
    pageSize = 100,
  } = params

  const {
    data: products,
    isLoading: isRecommendationsLoading,
    error: recommendationsError,
    triggerEvent,
  } = useRecommendationsAPI({
    modelType: 'similar-items',
    associatedItems,
    defaultEventType,
    pageSize,
  })

  return {
    data: products,
    isLoading: isRecommendationsLoading,
    error: recommendationsError,
    triggerDetailPageView: () => triggerEvent('detail-page-view'),
  }
}

export default useSimilarItems
